import React from 'react';
import headerbg from '../../assets/headerbg.webp';
import awardsNew from '../../assets/awardsnew.webp';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const stats = [
  { end: 10, suffix: '+', label: 'Years Of Experience' },
  { end: 4, suffix: '',    label: 'Global Offices' },
  { end: 43, suffix: '+',  label: 'Awards & Recognitions' },
  { end: 20, suffix: '+',  label: 'Countries With Live Projects' },
];
export default function Header() {
  return (
    <section className="w-full" id="about">
      {/* ─────────────────── Başlık + Açıklama ─────────────────── */}
      <div className="text-center font-questrial py-16 px-4 bg-gradient-to-b from-[#f8f8f8] to-white">
        <h2
          style={{ color: '#22282b' }}
          className="text-5xl md:text-7xl font-Questrial font-normal text-[#1a1a1a] leading-tight mt-5"
        >
          Unique Solutions <br /> For Changemakers.
        </h2>
        <p
          style={{ fontSize: '16px', fontWeight: '600' }}
          className="mt-4 text-[#22282B] font-manrope text-base max-w-xl mx-auto"
        >
          We deliver future-forward marketing campaigns that <br className="hidden md:block" />
          help brands lead with confidence and innovation.
        </p>
      </div>

      {/* ─────────────────── Orta Kısım ─────────────────── */}
    <div className="w-full h-auto md:h-[300px] lg:h-[550px] bg-cover bg-no-repeat bg-top"
        style={{
          // Opak layer ve background-image
          backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${headerbg})`,
        }}
      >
        <div className="w-full flex flex-col items-center justify-center h-full px-4 md:px-12 lg:px-24">
          {/* Awards görseli */}
          <div className="order-2 md:order-1 w-full flex justify-center mb-8 md:mb-0 md:mt-10 lg:mt-40">
           <img
             src={awardsNew}
              alt="Awards & recognitions"              className="w-full max-w-none object-contain"            />
         </div>

          {/* Başlık */}
          <div className="order-1 md:order-2 w-full flex justify-center md:justify-start px-8 pb-6 md:pl-10 lg:mb-36 md:mb-4">
            <h3 className="text-white text-3xl md:text-4xl lg:text-6xl font-light mt-8  lg:mt-16 text-center md:text-left ">
              <span className="hidden md:inline">Recent </span>Recognitions
            </h3>
          </div>
        </div>
      </div>

      {/* ─────────────────── Alt Kısım: Sayılar ─────────────────── */}
      <div className="bg-white py-10 px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-12 divide-x divide-gray-200">
          {stats.map(({ end, suffix, label }, idx) => (
            <div key={idx} className="flex flex-col items-start lg:items-center justify-center px-4">
              <h3 className="text-5xl font-manrope font-semibold text-[#22282B]">
                <CountUp 
                  start={0} 
                  end={end} 
                  duration={4} 
                  suffix={suffix}
                  enableScrollSpy 
                  scrollSpyOnce 
                />
              </h3>
              <p className="mt-1 text-sm text-gray-600 font-manrope font-medium whitespace-nowrap">
                {label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
